import { Component } from '@angular/core';
import { ICellRendererAngularComp} from '@ag-grid-community/angular';
import { ICellRendererParams} from '@ag-grid-community/core';

@Component({
  selector: 'carm-table-ag-grid-radio',
  templateUrl: './table-ag-grid-radio.component.html',
  styleUrls: ['./table-ag-grid-radio.component.scss'],
})
export class TableAgGridRadioComponent implements ICellRendererAngularComp {
  params;

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh(params?: ICellRendererParams): boolean {
    return true;
  }

  onSelection($event: ICellRendererParams) {
    if (this.params.onClick instanceof Function) {
      // pass entire row data back to parent
      const params = {
        event: $event,
        rowData: this.params.node.data,
      };
      this.params.onClick(params);
    }
  }
}
